import React from 'react'
import { Column } from 'primereact/column'
import { FilterMatchMode } from 'primereact/api'
import BooleanFilterTemplate from '../Filters/BooleanFilterTemplate'
import BooleanBodyTemplate from './BooleanBodyTemplate'
import { createFieldChangedChecker } from '../utils/createFieldChangedChecker'

const BooleanColumn = ({ title, mapsToField, filter, sortable, editable, isFieldChanged, isFieldChangedOverride, validationErrors, template, originalData, filterTemplate }) => {

    const filterAttributes = filter ? {
        filter: true,
        filterElement: filterTemplate || ((options) => <BooleanFilterTemplate options={options} />),
        filterMatchMode: FilterMatchMode.EQUALS,
        showFilterMatchModes: false
    } : {}

    const sortAttributes = {
        sortable,
        required: !!sortable,
        disabled: !sortable
    }

    // Create smart field changed checker
    const checkFieldChanged = createFieldChangedChecker({
        editable,
        isFieldChangedOverride,
        defaultIsFieldChanged: isFieldChanged,
        mapsToField,
        originalData
    })

    return (
        <Column
            {...sortAttributes}
            key={mapsToField}
            field={mapsToField}
            header={title}
            dataType="boolean"
            body={(rowData) => (
                <span className={checkFieldChanged(rowData) ? 'changed-field' : ''}>
                    {template ? template(rowData) : <BooleanBodyTemplate rowData={rowData} field={mapsToField} />}
                </span>
            )}
            {...filterAttributes}
        />
    )
}

export default BooleanColumn
